module.exports = __webpack_public_path__ + "static/media/shift-key.13a0b347.svg";